module.exports = __webpack_public_path__ + "img/abstract-shapes-lego1.2f14204a.svg";